var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyDebatesOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI kit"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow 3 (Stroke)",
    d: "M32.2315 14.8481L33.0894 13.9938H31.8787H6.5C5.94575 13.9938 5.5 13.5469 5.5 13C5.5 12.4531 5.94575 12.0062 6.5 12.0062H31.8787H33.0894L32.2315 11.1519L25.2462 4.19572C24.8567 3.8078 24.8567 3.17972 25.2462 2.7918C25.6369 2.40273 26.2712 2.40273 26.6619 2.7918L36.2078 12.298C36.5974 12.686 36.5974 13.314 36.2078 13.702L26.6619 23.2082C26.2712 23.5973 25.6369 23.5973 25.2462 23.2082C24.8567 22.8203 24.8567 22.1922 25.2462 21.8043L32.2315 14.8481Z",
    fill: "black",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 4 (Stroke)",
    d: "M9.76851 27.1519L8.91065 28.0062H10.1213L35.5 28.0062C36.0543 28.0062 36.5 28.4531 36.5 29C36.5 29.5469 36.0543 29.9938 35.5 29.9938L10.1213 29.9938H8.91065L9.76851 30.8481L16.7538 37.8043C17.1433 38.1922 17.1433 38.8203 16.7538 39.2082C16.3631 39.5973 15.7288 39.5973 15.3381 39.2082L5.79216 29.702C5.40261 29.314 5.40261 28.686 5.79216 28.298L15.3381 18.7918C15.7288 18.4027 16.3631 18.4027 16.7538 18.7918C17.1433 19.1797 17.1433 19.8078 16.7538 20.1957L9.76851 27.1519Z",
    fill: "black",
    stroke: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyDebatesOutlined);
export default __webpack_public_path__ + "static/media/icon-myDebates-outlined.f03fb0670670cfc025fe7b830190b8d0.svg";
export { ForwardRef as ReactComponent };